import _get from 'lodash/get';
import getCommaSeparatedList from './getCommaSeparatedList';
export default function translateConsumerInsights(personalization, consumerMarketingSegments, consumerAdTargets, consumerAdTargetsWithoutCAMPBias) {
  return {
    MkOfPrefMdl: personalization.makeOfPreferredModel || 'INCONCLUSIVE',
    PrefMdl: personalization.preferredModel || 'INCONCLUSIVE',
    PrefMdlConf: personalization.preferredModelConfidence || 'INCONCLUSIVE',
    MkOfSecPrefMdl: personalization.makeOfSecondPreferredModel || 'INCONCLUSIVE',
    SecPrefMdl: personalization.secondPreferredModel || 'INCONCLUSIVE',
    MktLevel: personalization.marketLevel || 'INCONCLUSIVE',
    PrefPrice: personalization.preferredPrice || 'INCONCLUSIVE',
    PrefVehType: personalization.preferredVehicleType || 'INCONCLUSIVE',
    PriceSensitivity: personalization.priceSensitivity || 'INCONCLUSIVE',
    PrefMk: personalization.preferredMake || 'INCONCLUSIVE',
    PrefBstyl: personalization.preferredBodystyle || 'INCONCLUSIVE',
    FixedOps: personalization.fixedOps || 'INCONCLUSIVE',
    PrefMileage: personalization.preferredMileage || 'INCONCLUSIVE',
    RecPrefMk: personalization.recentActivityPreferredMake || 'INCONCLUSIVE',
    RecPrefMdl: personalization.recentActivityPreferredModel || 'INCONCLUSIVE',
    MkOfRecPrefMdl: personalization.makeOfRecentActivityPreferredModel || 'INCONCLUSIVE',
    PrefFuelCat: personalization.preferredFuelCategory || 'INCONCLUSIVE',
    RecentPrefFuelCat: personalization.recentActivityPreferredFuelCategory || 'INCONCLUSIVE',
    pe_mod: getCommaSeparatedList(consumerAdTargets, 'targetModels', 'models', 'model') || 'INCONCLUSIVE',
    pe_alt_mod: getCommaSeparatedList(consumerAdTargets, 'targetModels', 'models', 'model', 2) || 'INCONCLUSIVE',
    pe_mk: getCommaSeparatedList(consumerAdTargets, 'targetMakes', 'makes', 'make') || 'INCONCLUSIVE',
    pe_subcat: getCommaSeparatedList(consumerAdTargets, 'targetSegments', 'segments', 'segment') || 'INCONCLUSIVE',
    pe_own_mk: _get(consumerAdTargets, 'targetTradeInVehicle.make.desc', 'INCONCLUSIVE'),
    pe_own_mod: _get(consumerAdTargets, 'targetTradeInVehicle.model.desc', 'INCONCLUSIVE'),
    pe_intent: _get(consumerAdTargets, 'targetIntent', 'INCONCLUSIVE'),
    pe_ins_exists: _get(consumerAdTargets, 'targetInsightsAvailable', 'INCONCLUSIVE').toString(),
    trackingId: personalization.trackingId || 'INCONCLUSIVE',
    pe_cons_mod: getCommaSeparatedList(consumerAdTargetsWithoutCAMPBias, 'targetModels', 'models', 'model', 1) || 'INCONCLUSIVE',
    pe_cons_alt_mod: getCommaSeparatedList(consumerAdTargetsWithoutCAMPBias, 'targetModels', 'models', 'model', 2) || 'INCONCLUSIVE',
    pe_cons_mk: getCommaSeparatedList(consumerAdTargetsWithoutCAMPBias, 'targetMakes', 'makes', 'make') || 'INCONCLUSIVE',
    pe_cons_subcat: getCommaSeparatedList(consumerAdTargetsWithoutCAMPBias, 'targetSegments', 'segments', 'segment') || 'INCONCLUSIVE',
    pe_cons_intent: _get(consumerAdTargetsWithoutCAMPBias, 'targetIntent', 'INCONCLUSIVE'),
    pe_cons_own_mk: _get(consumerAdTargetsWithoutCAMPBias, 'targetTradeInVehicle.make.desc', 'INCONCLUSIVE'),
    pe_cons_own_mod: _get(consumerAdTargetsWithoutCAMPBias, 'targetTradeInVehicle.model.desc', 'INCONCLUSIVE'),
    pe_demographics: _get(consumerMarketingSegments, 'demographics', 'INCONCLUSIVE'),
    pe_lifeevents: _get(consumerMarketingSegments, 'lifeEvents', 'INCONCLUSIVE'),
    pe_clusters: _get(consumerMarketingSegments, 'clusters', 'INCONCLUSIVE')
  };
}